import React, { useEffect, useMemo, useState } from 'react';
import '../../styles/common/imgSlider/imgSlider.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
import { BusImgLeftArrow, BusImgRightArrow, SlideCross } from './icons/svg';
const ImageSlider = ({ slides, handleSlider, busSeriveType, img }) => {
    const [current, setCurrent] = useState(0);
    const [imgList, setImgList] = useState(img);
    const length = imgList.length;
    const nextSlide = (e) => {
        console.log("e", e.target)
        e.preventDefault();
        setCurrent(current === length - 1 ? 0 : current + 1);
    };

    const prevSlide = (e) => {
        e.preventDefault();
        setCurrent(current === 0 ? length - 1 : current - 1);
    };

    if (!Array.isArray(imgList) || imgList.length <= 0) {
        return null;
    }

    return (
        <React.Fragment>
            <div className='bus--slider'>
                {/* <div className='slideCross' onClick={() => handleSlider(false)}><SlideCross /></div> */}
                <div className='left-arrow' onClick={prevSlide}><BusImgLeftArrow /></div>
                <div className='right-arrow' onClick={nextSlide}><BusImgRightArrow /></div>
                {imgList.map((slide, index) => {
                    return (
                        <div
                            className={index === current ? 'bus--slide active' : 'bus--slide'}
                            key={index}
                        >
                            {index === current && (
                                <LazyLoadImage
                                    src={slide}
                                    alt='travel image'
                                    className='image'
                                // effect="blur"
                                />
                                // <img src={slide} alt='travel image' className='image' />
                            )}
                        </div>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

export default ImageSlider;